<template>
  <label
    class="inline-flex justify-center"
    :class="[$data.staticClass, $data.class]"
  >
    <span class="mr-2 self-center u-beta">
      <slot>Field label:</slot>
    </span>
    <span
      class="bg-bg rounded-md tint:focus-within:hover max-md:w-10 w-14 items-center flex"
      :class="[boundsClasses]"
    >
      <base-field
        @input="value => $emit('input', value)"
        class=" font-light font-sans py-1 w-full text-center "
        v-bind="{ ...$attrs }"
        size="3"
        style="transform-origin: 2.5rem 50%"
      />
    </span>
  </label>
</template>

<script>
import BaseField from '@/components/BaseField'

export default {
  name: `LabelledFieldInput`,
  inheritAttrs: false,
  components: {
    BaseField,
  },
  props: {
    boundsClasses: {
      default: ``,
    },
  },
}
</script>
